import { render, staticRenderFns } from "./EventSignalChip.vue?vue&type=template&id=df47d1a6&scoped=true"
import script from "./EventSignalChip.vue?vue&type=script&lang=js"
export * from "./EventSignalChip.vue?vue&type=script&lang=js"
import style0 from "./EventSignalChip.vue?vue&type=style&index=0&id=df47d1a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df47d1a6",
  null
  
)

export default component.exports